exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.background {\n  background-color:#E4E4E4;\n}\n.export-vaccin-btn {\n  padding: 0 20px;\n  background-color: #FF8EA1;\n  color: white;\n  line-height: 30px;\n  border-radius: 15px;\n  text-align: center;\n  float: right;\n  position: relative;\n  top: -5px;\n}\n.export-vaccin-btn:hover {\n  cursor: pointer;\n}\n", ""]);

// exports
